import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useGetDetailSensor(interfaceId: number) {
  return useQuery({
    queryKey: [queryKeys.sensorOptions],
    queryFn: async () => {
      const { data } = await flowSensorApi.getDetails(interfaceId)

      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useGetDetailSensor
